import i18n from "i18next";

export const LANGUAGE_STORAGE_KEY = "i18nextLng";
export const LANGUAGE_OVERRIDE_SESSION_KEY = "languagePreferenceChanged";

export const normalizeLanguage = (lang?: string | null) => {
  const normalized = lang?.trim().toLowerCase();
  return normalized?.startsWith("ar") ? "ar" : "en";
};

export const normalizeOptionalLanguage = (lang?: string | null) => {
  return lang?.trim() ? normalizeLanguage(lang) : null;
};

export const getPersistedLanguage = () => {
  const candidates = [
    typeof window !== "undefined"
      ? window.localStorage.getItem(LANGUAGE_STORAGE_KEY)
      : null,
    typeof document !== "undefined" ? document.documentElement.lang : null,
    i18n.resolvedLanguage,
    i18n.language,
    typeof navigator !== "undefined" ? navigator.language : null,
  ];

  const language = candidates.find((candidate) => candidate?.trim());
  return normalizeLanguage(language);
};

export const applyLanguageToDocument = (lang: string) => {
  const normalizedLanguage = normalizeLanguage(lang);

  if (typeof document !== "undefined") {
    document.documentElement.dir = normalizedLanguage === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = normalizedLanguage;
  }

  return normalizedLanguage;
};

export const changeLanguage = async (
  lang: string,
  { markAsUserChange = true }: { markAsUserChange?: boolean } = {},
) => {
  const normalizedLanguage = normalizeLanguage(lang);

  if (typeof window !== "undefined") {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, normalizedLanguage);
    if (markAsUserChange) {
      sessionStorage.setItem(LANGUAGE_OVERRIDE_SESSION_KEY, "true");
    }
  }

  applyLanguageToDocument(normalizedLanguage);

  await i18n.changeLanguage(normalizedLanguage);

  return normalizedLanguage;
};
